import PropTypes from "prop-types"
import React, { useContext, useEffect, useRef, useState } from "react"
import { Collapse, UncontrolledCollapse } from 'reactstrap';

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import { Context } from "../../app-contexts/CommonContexts"
import uuid from 'react-uuid'

const SidebarContent = props => {
  const ref = useRef()

  const {
    isHeadOfficeURL, setIsHeadOfficeURL
  } = useContext(Context);

  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false
    }
    scrollElement(item);
    return false
  }

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul key={uuid()} className="metismenu list-unstyled" id="side-menu">
            {props.menuItems.map(parent => {
              if (parent?.strMenuTag == 'F00000') {
                return (
                  <div key={uuid()}>
                    <li key={uuid()}>
                      <Link key={uuid()} id={parent?.strMenuTag} className="">
                        <i key={uuid()} className={`bx ${parent?.strIcon}`}></i>
                        <span key={uuid()} id={"RootLabelText"}>{parent?.strMenuName}</span>
                      </Link>
                      <ul key={uuid()} className="sub-menu" aria-expanded="false">
                        {parent?.lstChildren.map((child) => {
                          if (child.strParentMenu == parent?.strMenuTag && child.menuDisplay) {
                            return (
                              <li key={uuid()}>
                                {child.strUrl.charAt(0) == "/" ?
                                  <Link key={uuid()} to={child.strUrl} onClick={() => {
                                    localStorage.setItem('MenuCode', child.strMenuTag)
                                    localStorage.setItem('ParentName', parent?.strMenuName)
                                  }}>{child.strMenuName}</Link> :
                                  <a key={uuid()} href={child.strUrl.toString()} target="_blank" onClick={() => {
                                    localStorage.setItem('MenuCode', child.strMenuTag);
                                    localStorage.setItem('ParentName', parent?.strMenuName);
                                    setIsHeadOfficeURL(child.isHeadOffice);
                                  }}>{child.strMenuName}</a>}
                              </li>
                            )
                          }
                        })}
                      </ul>
                    </li>
                  </div>
                )
              } else {
                return (
                  <div key={uuid()}>
                    <li key={uuid()}>
                      <Link key={uuid()} id={parent?.strMenuTag} className="">
                        <i key={uuid()} className={`bx ${parent?.strIcon}`}></i>
                        <span key={uuid()} id={"RootLabelText"}>{parent?.strMenuName}</span>
                      </Link>
                      <UncontrolledCollapse toggler={`#${parent?.strMenuTag}`} key={uuid()}>
                        <ul key={uuid()} className="sub-menu" aria-expanded="false">
                          {parent?.lstChildren.map((child) => {
                            if (child.strParentMenu == parent?.strMenuTag && child.menuDisplay) {
                              return (
                                <li key={uuid()}>
                                  {child.strUrl.charAt(0) == "/" ?
                                    <Link key={uuid()} to={child.strUrl} onClick={() => {
                                      // localStorage.setItem('MenuCode', child.strMenuTag)
                                      // localStorage.setItem('ParentName', parent?.strMenuName)
                                      setIsHeadOfficeURL(child.isHeadOffice)
                                    }}>{child.strMenuName}</Link> :
                                    <a key={uuid()} href={child.strUrl.toString()} target="_blank" onClick={() => {
                                      // localStorage.setItem('MenuCode', child.strMenuTag);
                                      // localStorage.setItem('ParentName', parent?.strMenuName);
                                      setIsHeadOfficeURL(child.isHeadOffice);
                                    }}>
                                      {child.strMenuName}
                                    </a>
                                  }
                                </li>
                              )
                            }
                          })}
                        </ul>
                      </UncontrolledCollapse>
                    </li>
                  </div>
                )
              }
            })}
          </ul>
        </div> 
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
